import axios from 'axios';
import { useAuthStore } from '@/store/auth.store';
const BASE_URL = import.meta.env.VITE_API_URL ?? '/';
// ✅ Using the same axios instance with withCredentials for refresh calls
const refreshClient = axios.create({
    baseURL: BASE_URL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});
export const apiClient = axios.create({
    baseURL: BASE_URL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});
let isRefreshing = false;
let refreshSubscribers = [];
apiClient.interceptors.request.use((config) => {
    const state = useAuthStore.getState();
    const token = state.accessToken;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        console.info(`[api] → ${config.method?.toUpperCase()} ${config.url}`, {
            hasTenant: !!state.tenant?.id,
            tenantId: state.tenant?.id,
            tokenPrefix: token.substring(0, 20) + '...',
        });
    }
    else {
        console.warn(`[api] → ${config.method?.toUpperCase()} ${config.url} — SIN TOKEN`);
    }
    // Solo enviar X-Tenant-ID si hay un tenant real en el store (no el hostname del browser)
    if (state.tenant?.id) {
        config.headers['x-tenant-id'] = state.tenant.id;
    }
    else if (state.tenant?.slug) {
        config.headers['x-tenant-id'] = state.tenant.slug;
    }
    return config;
});
apiClient.interceptors.response.use((res) => res, async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const errorMsg = error.response?.data?.message ?? error.message;
    // Loguear TODOS los errores 401 con detalles
    if (status === 401) {
        console.warn(`[api] 401 en ${original?.url}: ${errorMsg}`);
        console.warn(`[api] Token enviado: ${error.config?.headers?.Authorization?.substring(0, 30)}...`);
    }
    if (!original)
        return Promise.reject(error);
    const isRefreshUrl = original.url?.includes('/auth/refresh');
    if (status === 401 && !isRefreshUrl && !original._retry) {
        original._retry = true;
        const store = useAuthStore.getState();
        if (!store.accessToken || !store.refreshToken) {
            console.warn('[api] 401 sin tokens, desautenticando:', original.url);
            store.logout();
            return Promise.reject(error);
        }
        if (!isRefreshing) {
            isRefreshing = true;
            console.info('[api] Access token expirado, intentando refresh...');
            const currentAccessToken = store.accessToken;
            const currentRefreshToken = store.refreshToken;
            const currentTenant = store.tenant;
            apiClient
                .post('/api/v1/auth/refresh', { refreshToken: currentRefreshToken }, { withCredentials: true })
                .then(({ data }) => {
                const newAccessToken = data.accessToken;
                const newRefreshToken = data.refreshToken;
                store.setAuth(store.user, store.tenant, newAccessToken, newRefreshToken);
                isRefreshing = false;
                const subscribers = refreshSubscribers.splice(0);
                subscribers.forEach((cb) => cb(newAccessToken, currentTenant?.id));
                original.headers.Authorization = `Bearer ${newAccessToken}`;
                const tid = currentTenant?.id;
                if (tid)
                    original.headers['x-tenant-id'] = tid;
                return apiClient(original);
            })
                .catch((refreshError) => {
                isRefreshing = false;
                refreshSubscribers = [];
                const refreshStatus = refreshError.response?.status;
                const refreshMsg = refreshError.response?.data?.message ?? refreshError.message;
                console.warn(`[api] Refresh falló (${refreshStatus}): ${refreshMsg}`);
                store.logout();
                return Promise.reject(error);
            });
        }
        return new Promise((resolve) => {
            refreshSubscribers.push((newToken, tenantId) => {
                original.headers.Authorization = `Bearer ${newToken}`;
                if (tenantId)
                    original.headers['x-tenant-id'] = tenantId;
                resolve();
            });
        }).then(() => apiClient(original));
    }
    if (status !== 401) {
        console.warn(`[api] Error no-401 en ${original.url}: ${status} — ${errorMsg}`);
    }
    return Promise.reject(error);
});
//# sourceMappingURL=client.js.map